import { SetterOrUpdater } from "recoil";
import { filterSelectorProps } from "../../actions/LayoutMode.actions";

export interface DataTableProps {
  columns: any;
  data: any;
  isGlobalFilter?: any;
  isAddOptions?: any;
  isAddUserList?: any;
  isAddInvoiceList?: any;
  handleOrderClicks?: any;
  handleUserClick?: any;
  handleCustomerClick?: any;
  isAddCustList?: any;
  customPageSize: any;
  className?: any;
  handleInvoiceClick?: any;
  theadClass?: any;
  isBordered?: boolean;
  setFilterState?: SetterOrUpdater<filterSelectorProps>;
  pageCountTable?: number;
  pageIndexList?: number;
  hasCustomPagination?: boolean;
  canPreviusPageCustom?: boolean;
  canNextPageCustom?: boolean;
}

export const splitNumberIntoPages = (number: number, pageSize: number) => {
  const pages = [];
  let start = 0;
  let index = 0;

  while (start < number) {
    pages.push(index);
    start += pageSize;
    index++;
  }

  return pages;
};
